export default __webpack_public_path__ + "static/media/gallery_02.52275ea8.jpg";